import { PaddedSurface } from "App/global-style";
import styled from "styled-components";

export const NoCarsFoundSurface = styled(PaddedSurface)`
  background-color: #fff;
`;

export const VehicleContainer = styled(PaddedSurface)`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  gap: var(--spacer-s);
  justify-content: space-between;

  @media screen and (max-width: 482px) {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--spacer-sx);
  }
`;
